var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "scroll-lock",
          rawName: "v-scroll-lock",
          value: false,
          expression: "false"
        }
      ],
      staticClass: "zoom-on-hover",
      class: _vm.classes,
      on: { mousemove: _vm.move, mouseenter: _vm.zoom, mouseleave: _vm.unzoom }
    },
    [
      _c(
        "img",
        _vm._b(
          { ref: "normal", staticClass: "normal" },
          "img",
          _vm.imgNormalAttrs,
          false
        )
      ),
      _vm._v(" "),
      _c(
        "img",
        _vm._b(
          {
            ref: "zoom",
            staticClass: "zoom",
            style:
              "top: " +
              _vm.position.y +
              "px; left: " +
              _vm.position.x +
              "px; transform: scale(" +
              (_vm.isZooming ? _vm.scale : 1) +
              ")",
            on: {
              touchmove: function($event) {
                $event.stopPropagation()
                $event.preventDefault()
                return _vm.move($event)
              }
            }
          },
          "img",
          _vm.imgZoomAttrs,
          false
        )
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }